import styled from "styled-components";
import ReactTooltip from "react-tooltip";

import { fonts, A } from "./";

export const Tooltip = styled(ReactTooltip).attrs({ place: "bottom" })`
    &.__react_component_tooltip.type-dark.place-bottom {
        opacity: 1;
        background-color: #41414d;
        border-radius: 0;
        width: 16.4375rem;
        padding: 0.875rem 1rem 1.25rem;
        ${fonts.typeScale[14]}

        &:after {
            border-bottom-color: #41414d;
        }
    }

    ${A} {
        color: ${fonts.fontColors.light.primary} !important;
    }
`;
